(() => {
  const ROOT_SELECTOR = '[data-paths-contact]';

  function initPathsContact(root) {
    if (!root || root.dataset.pathsContactInitialized === 'true') return;

    root.dataset.pathsContactInitialized = 'true';

    const form = root.querySelector('#PathsContactForm');
    const message = form?.querySelector('textarea[name="contact[body]"]');
    const characterCount = root.querySelector('[data-paths-contact-count]');
    const successMessage = root.querySelector('[data-paths-contact-success]');

    function updateCharacterCount() {
      if (!message || !characterCount) return;

      const length = message.value.length;

      characterCount.textContent =
        length === 1
          ? '1 character'
          : `${length} characters`;
    }

    message?.addEventListener('input', updateCharacterCount);

    updateCharacterCount();

    if (successMessage) {
      window.requestAnimationFrame(() => {
        successMessage.focus({
          preventScroll: true,
        });
      });
    }
  }

  function initAllPathsContacts(scope = document) {
    scope
      .querySelectorAll(ROOT_SELECTOR)
      .forEach(initPathsContact);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllPathsContacts();
    });
  } else {
    initAllPathsContacts();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllPathsContacts(event.target);
  });
})();